import Vue from 'vue';
import { MutationTree } from 'vuex';
import { Course, CourseState, Modality } from './state';

const mutations: MutationTree<CourseState> = {
  SET_COURSE(state, course: Course) {
    state.course = course;
  },
  SET_AVAILABLE_COURSES(state, availableCourses: Course[]) {
    state.availableCourses = availableCourses;
  },
  SET_MODALITY(state, modality: Modality) {
    state.modality = modality;
  },
};

export default mutations;
